import { Component, OnDestroy, OnInit } from '@angular/core';
import { PostingService } from 'app/core/services/posting.service';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { Subscription } from 'rxjs/Subscription';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TypeCreditsEnum } from 'app/core/enums/type-credits.enum';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { creditTypesEnum } from '../posting.component';

@Component({
  selector: 'app-modal-charges-details',
  templateUrl: './modal-charges-details.component.html',
  styleUrls: ['./modal-charges-details.component.scss']
})
export class ModalChargesDetailsComponent implements OnInit, OnDestroy {

  subscription: Subscription[] = [];
  formCharges: FormGroup;
  contractualArray = [];
  rollbackReason: string;

  constructor(private postingService: PostingService,
    private sweetAlertHelper: SweetAlertHelper,
    private fb: FormBuilder,
    private t2LoadingService: T2LoadingService,
  ) {
    this.initFormCharges();
  }

  ngOnDestroy(): void {
    this.subscription.forEach((subs) => subs.unsubscribe());
  }

  ngOnInit() {
    this.subcriptions();
  }

  initFormCharges(): void {
    this.rollbackReason = null;
    this.formCharges = this.fb.group({
      dateofservice: [null, [Validators.required]],
      payordescription: [null],
      payorid: [null, [Validators.required]],
      riderfullname: [null],
      totalamounttrip: [null],
      tripid: [null, [Validators.required]],
      claim: [null],
      consecutive: [null],
      batchinfoid: [null, [Validators.required]],
      batchcreditid: [null],
      chargeList: this.fb.array([])
    });
  }

  get chargeList(): FormArray {
    return this.formCharges.get('chargeList') as FormArray;
  }

  onSave(): void {
    if (this.formCharges.valid) {
      this.t2LoadingService.show();
      const formCharge = this.formCharges.getRawValue();
      formCharge.chargeList.filter((item) => delete item.creditList);
      this.postingService.postSaveBatchCredit(formCharge).subscribe((resp) => {
        if (resp) {
          this.sweetAlertHelper.createCustomAlert({
            title: 'Success',
            text: resp.message,
            type: 'success',
          }).then(() => {
            this.onCancelCharges();
            this.postingService.setBatchInfoId(formCharge.batchinfoid);
            this.t2LoadingService.hiden();
          });
        }
      }, (err) => this.sweetAlertHelper.captureException(err).then(() => this.t2LoadingService.hiden()));
    } else {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Error',
        text: '¡Action not allowed!',
        type: 'error'
      }).then(() => {
        this.onCancelCharges();
      });
    }
  }

  getTypeCreditList(type: number, i?: number): void {
    this.subscription.push(
      this.postingService.getCreditTypeList(type).subscribe((resp) => {
        if (type === creditTypesEnum.contractual) {
          this.contractualArray = resp;
          return;
        }
        if (resp) {
          this.chargeList.controls[i].patchValue({
            creditList: resp.filter((item) => item.credittypeid === type)
          });
        }
      },
        (error) => this.sweetAlertHelper.captureException(error)
      )
    );
  }

  getContractualesCredit(type: number): void {
    this.subscription.push(
      this.postingService.getCreditTypeList(type).subscribe((resp) => {
        if (resp) {
          this.contractualArray = resp;
        }
      },
        (error) => this.sweetAlertHelper.captureException(error)
      )
    );
  }


  subcriptions(): void {
    this.subscription.push(
      this.postingService.creditEditSubject$.subscribe((resp: any) => {
        this.setValueForm(resp);
      })
    );

    this.subscription.push(
      this.postingService.batchInfoId.subscribe((batchInfoId: number) => {
        if (batchInfoId) {
          this.formCharges.get('batchinfoid').setValue(batchInfoId);
        }
      })
    );
  }

  setValueForm(resp): void {
    if (resp) {
      this.formCharges.patchValue({
        dateofservice: resp.dateofservice,
        payordescription: resp.payordescription,
        payorid: resp.payorid,
        riderfullname: resp.riderfullname,
        totalamounttrip: resp.totalamounttrip,
        tripid: resp.tripid,
        consecutive: resp.consecutive,
        claim: resp.claim
      });
      if (resp.chargeslist) {
        resp.chargeslist.filter((item) => {
          this.chargeList.push(
            this.fb.group({
              cptmod: [{ value: item.cptmod, disabled: true }],
              chargedescription: [{ value: item.chargedescription, disabled: true }],
              billed: [{ value: item.billed, disabled: true }],
              allowance: [{ value: item.allowance, disabled: true }],
              payment: [{ value: item.payment, disabled: true }],
              balance: [{ value: item.balance, disabled: true }],
              amount: [null, Validators.required],
              creditid: [null],
              denialcode: [{ value: null, disabled: true }],
              contractualamount: [null, [Validators.required]],
              contractualcreditid: [null],
              newbalance: [{ value: item.balance, disabled: true }],
              tripchargeid: [item.tripchargeid, [Validators.required]],
              domod: [item.domod],
              procd: [item.procd],
              pumod: [item.pumod],
              creditList: []
            })
          );
        });
      }
    }

  }

  onCancelCharges(): void {
    this.rollbackReason = null;
    this.postingService.modalChargesDetails.emit({ isOpen: false });
  }

  onChangeAmount(i: number): void {
    this.chargeList.controls[i]['controls'].denialcode.setValue(null);
    this.chargeList.controls[i]['controls'].creditid.setValue(null);
    const formCharge = this.formCharges.getRawValue().chargeList[i];
    const { amount } = formCharge;
    if (amount) {
      this.getCreditList(amount, i);
      this.setValidatorsControl(i, 'creditid', Validators.required);
      this.setMassiveValidators(null);
    } else {
      this.chargeList.controls[i]['controls'].creditList.setValue(null);
      this.setValidatorsControl(i, 'creditid', null);
      this.changeStatusControl();
    }
    this.getNewBalance(i, formCharge);
  }

  getCreditList(amount, i: number): void {
    const zero = 0;
    if (Number(amount) === zero) {
      this.getTypeCreditList(creditTypesEnum.denials, i);
    }
    if (Number(amount) > zero) {
      this.getTypeCreditList(creditTypesEnum.payment, i);
    }
    if (Number(amount) < zero) {
      this.getTypeCreditList(creditTypesEnum.refund, i);
    }
  }

  onChangeCredit(i: number): void {
    const formCharge = this.formCharges.getRawValue().chargeList[i];
    if (!formCharge.creditid) {
      this.chargeList.controls[i]['controls'].amount.setValue(null);
      this.chargeList.controls[i]['controls'].creditList.setValue(null);
      this.setValidatorsControl(i, 'creditid', null);
      this.changeStatusControl();
    }
    if (Number(formCharge.creditid) !== TypeCreditsEnum.Denials) {
      this.chargeList.controls[i]['controls'].denialcode.setValue(null);
      this.chargeList.controls[i]['controls'].denialcode.disable();
      this.setValidatorsControl(i, 'denialcode', null);
      return;
    }
    this.chargeList.controls[i]['controls'].denialcode.enable();
    this.setValidatorsControl(i, 'denialcode', Validators.required);
  }

  setValidatorsControl(index: number, property: string, validators): void {
    this.chargeList.controls[index].get(property).setValidators(validators);
    this.chargeList.controls[index].get(property).updateValueAndValidity();
  }

  onChangeContractualAmount(i: number): void {
    this.chargeList.controls[i].get('contractualcreditid').setValue(null);
    const formCharge = this.formCharges.getRawValue().chargeList[i];
    if (formCharge.contractualamount) {
      this.getTypeCreditList(creditTypesEnum.contractual);
      this.setValidatorsControl(i, 'contractualcreditid', Validators.required);
      this.setMassiveValidators(null);
    } else {
      this.setValidatorsControl(i, 'contractualcreditid', null);
      this.changeStatusControl();
    }
    this.getNewBalance(i, formCharge);
  }

  onContractualcreditid(i: number): void {
    const formCharge = this.formCharges.getRawValue().chargeList[i];
    if (!formCharge.contractualcreditid) {
      this.contractualArray = [];
      this.chargeList.controls[i]['controls'].contractualamount.setValue(null);
      this.setValidatorsControl(i, 'contractualcreditid', null);
      this.changeStatusControl();
    }
  }

  changeStatusControl(): void {
    let swt = false;
    this.chargeList.value.forEach((element, index) => {
      if (element.amount || element.contractualamount) {
        swt = true;
        this.setValidatorsControl(index, 'amount', null);
        this.setValidatorsControl(index, 'contractualamount', null);
      }
    });

    if (!swt) {
      this.setMassiveValidators(Validators.required);
    }
  }

  getNewBalance(index: number, formCharge): void {
    const { balance, amount, contractualamount } = formCharge;
    const amountOperation = Number(amount) + Number(contractualamount);
    const sumAmount = Number(balance) - (amountOperation);
    this.chargeList.controls[index]['controls'].newbalance.setValue(sumAmount);
  }

  setMassiveValidators(validator): void {
    this.chargeList.value.filter((element, index) => {
      this.setValidatorsControl(index, 'amount', validator);
      this.setValidatorsControl(index, 'contractualamount', validator);
    });
  }

  get currentBalance(): string {
    const totalAmountBalance = this.formCharges.get('totalamounttrip').value;
    return `$${Number.parseFloat(totalAmountBalance).toFixed(2)}`;
  }

  get riderFullName(): string {
    return this.formCharges.get('riderfullname').value;
  }

  get dateOfservice(): string {
    return this.formCharges.get('dateofservice').value;
  }

  get consecutiveNumber(): string {
    return this.formCharges.get('consecutive').value;
  }

  get payorDescription(): string {
    return this.formCharges.get('payordescription').value;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/billing-general/posting/modal-charges-details/modal-charges-details.component.ts